module.exports = {"svg":{"$":{"t":"1533717136501","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"4681","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"64","height":"64"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M63.444473 707.321524l54.503335 56.092529 392.468626-403.917376 392.474766 403.917376 54.502311-56.092529L510.416434 247.317759 63.444473 707.321524zM63.444473 707.321524","p-id":"4682"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/uparrow.svg
// module id = M9p7
// module chunks = 91